import React from "react";
import Button from "react-bootstrap/Button";
import "../style/Login.css";
import { Modal } from "react-bootstrap";
import { apiFetchJson } from "../api";



const DelFeedback = ( { feedbackID, open, onClose }) => {

    const handleCancel = event => {
        // console.log('Cancel');
        onClose(false);
    }


    function handleDelete() {
        apiFetchJson('/api/delfeedback/' + feedbackID, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then(data => {
            // setStatus(data.status);
            console.log(data.message);
            onClose(false);
        });
    }

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={open}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton={false}>
                <Modal.Title>Delete feedback?</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="primary"  onClick={handleDelete}>
                    Delete
                </Button>
            </Modal.Footer>

        </Modal>
    );
}

export default DelFeedback;
